import { Divider, Grid, Typography } from "@mui/material";
import React from "react";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { FormProvider, useForm } from "react-hook-form";
import { FilterCriteria } from "./FilterCriteria";
import { OtherSettings } from "./OtherSettings";
import config from "../../Config/clientConfig.json";
import WSSelectField from "../../Components/Select/WSSelect";
import WSDateField from "../../Components/DateField/WSDateField";

export const ServingPeriodReport:React.FC<any>=React.memo((props)=>{
  const { handleSubmit, control, register } = useForm();
   
      const onSubmit = async (data: any) => {
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };
    return(
              <form onSubmit={handleSubmit(onSubmit)}  style={{ width: '100%' }}>

                <Typography sx={{fontWeight: 500,fontSize: "0.875rem",color:"#1976d2"}}>FILTER CRITERIA</Typography>
                <Divider sx={{mt:1}}/>
                <Grid container spacing={2} sx={{mt:3}}>

      <Grid item xs={12} sm={2}>
        <Typography>From Date</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSDateField
          id="fromdate"
          name="fromdate"
          label=""
          dateFormat="D/MM/YYYY"
          control={control}
          defaultValue={null}
          rules={{ required: false }}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>To Date</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSDateField
          id="todate"
          name="todate"
          label=""
          dateFormat="D/MM/YYYY"
          control={control}
          defaultValue={null}
          rules={{ required: false }}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>User</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSSelectField
          rules={{ required: true }}
          {...register("user")}
          id="user"
          control={control}
          defaultValue={"0"}
          label=""
          name="user"
          options={config.userConfig.staticOptionData}
        />
      </Grid>
      </Grid>
            </form>
    )
})